import { client, formatQueryParams } from 'util/sdk';

export default ({ fspId, ...params }) =>
  client.fsps(fspId).userAuditLogs.query(formatQueryParams(params));
